// styled-components.ts
import * as styledComponents from 'styled-components';
import { ThemedStyledComponentsModule } from 'styled-components';
import { ITheme } from './theme';

const {
  default: styled,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider,
  withTheme,
} = styledComponents as ThemedStyledComponentsModule<ITheme>;

export interface IThemeProps {
  theme: ITheme;
}

export { css, createGlobalStyle, keyframes, ThemeProvider, withTheme };
export default styled;
